import { SelectedFilters } from '@/components/FilterData/types';
import { getApiError } from '@/types/apiError';
import { useQuery } from '@tanstack/react-query';
import { queryFunction, queryKey } from './query';
import { UUID } from '@/api/generatedApi';

export const useCrossTenantPartSearch = ({
  assetId,
  assetTenantId,
  searchTenantId,
  searchQuery,
  selectedFilters,
  minThreshold,
  page,
  perPage,
  enabled = true,
}: {
  assetId: UUID;
  assetTenantId: UUID;
  searchTenantId: UUID;
  searchQuery?: string;
  selectedFilters?: SelectedFilters;
  minThreshold: number;
  page?: number;
  perPage?: number;
  enabled?: boolean;
}) => {
  const { data, isLoading, error } = useQuery({
    queryKey: queryKey({
      assetId,
      assetTenantId,
      searchTenantId,
      searchQuery,
      selectedFilters,
      minThreshold,
      page,
      perPage,
    }),
    queryFn: queryFunction({
      assetId,
      assetTenantId,
      searchTenantId,
      searchQuery,
      selectedFilters,
      minThreshold,
      page,
      perPage,
    }),
    enabled: enabled && !!assetId && !!assetTenantId && !!searchTenantId,
  });

  return { data: data?.data, isLoading, error: getApiError(error) };
};
